// extracted by mini-css-extract-plugin
export default {"parent-mode":"page_parent-mode__clp9U","page":"page_page__gPLLk","updateTitle":"page_updateTitle__+ubaJ","updateText":"page_updateText__3+OR7","loader":"page_loader__AHjNq"};